<ion-button
  type="button"
  [class]="cssClass"
  [fill]="fill"
  (click)="onBack()"
  (keydown)="onKeydown($event)"
>
  <ion-icon
    name="chevron-back-outline"
    [attr.slot]="useIconOnlySlot ? 'icon-only' : null"
    [color]="iconColor"
    aria-hidden="true"
  ></ion-icon>
  <!-- Prefer sr-only text over host aria-label binding: Ionic watches aria-label and can throw
       when Angular sets it before $lazyInstance$ is ready (onAriaChanged). -->
  <span class="sr-only">{{ ariaLabelKey | translate }}</span>
</ion-button>
